module.exports = __webpack_public_path__ + "static/media/1029626.b4ea51fd.jpg";